import { Modal } from '@doordash/component-modal'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { SupportedCountryCode } from '../../../models/types'

import { bulletPointsUS } from './constants'
import t from './strings'
import { BulletItem } from './styles'

type Props = {
  country?: SupportedCountryCode
  onClose: void
}

export const AcceptableIdModal: React.SFC<Props> = props => (
  <Modal
    {...props}
    title={t.title()}
    primaryAction={{
      text: t.primaryAction(),
      onClick: props.onClose,
    }}
    actionsFillContainer
    size={Modal.Sizes.Medium}
  >
    <StackChildren size={StackChildren.Sizes.Large}>
      <ul>
        {bulletPointsUS.map(data => {
          return (
            <BulletItem>
              <Text styles={Text.Styles.PageDescriptionBody}>{data}</Text>
            </BulletItem>
          )
        })}
      </ul>
    </StackChildren>
  </Modal>
)

export default AcceptableIdModal
